/**
 * 페이지 관련 상수 정의
 */

export const PAGE_VIEW = {
    CARD: "card",
    TABLE: "table",
};

export const PAGE_SORT_KEY = {
    LABEL_MEMBER_POSITION: "label.MEMBER_POSITION",
    LABEL_MEMBER_RESPONSIBILITY: "label.MEMBER_RESPONSIBILITY",
    LABEL_MEMBER_RANK: "label.MEMBER_RANK",
};

export const PAGE_CONDITION_KEY = {
    DOCUMENT_LABEL_LABEL_ID: "documentLabel.labelId",
    DOCUMENT_LABEL_LABEL_ID_DOCUMENT_TYPE: "documentLabel.DOCUMENT_TYPE",
    DOCUMENT_LABEL_LABEL_ID_APPROVAL_REQUEST_REASON: "documentLabel.APPROVAL_REQUEST_REASON",
};

export const PAGE_SORT_ORDER = {
    ASC: "ASC",
    DESC: "DESC",
} as const;

export const PAGE_PERIOD = {
    UNLIMITED: "unlimited",
    RANGE: "range",
} as const;

export const PAGE_CONDITION_CONNECTOR = {
    AND: "and",
    OR: "or",
} as const;
